module.exports = __webpack_public_path__ + "static/media/IMG_1538 - Version 2.f54eb27c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_1538 - Version 2.JPG
// module id = 520
// module chunks = 0